module.exports = __webpack_public_path__ + "img/undraw_page_not_found.6695af99.svg";